import { NotFound } from 'component/errors/not-found';
import { useLocalSearchParams } from 'expo-router';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { useEnabledFeatures } from 'util/features-hooks';
import { ParamProvider } from 'util/params';

type RecordingVoteSearchParams = {
    csrfToken1: string;
    sliderValue1: string;
    voteKey1: string;
    voteLabel1: string;
};

export default function SpaceRecordingVoteScreen() {
    const { csrfToken1, sliderValue1, voteKey1, voteLabel1 } = useLocalSearchParams<
        '/[siloKey]/question/[instanceKey]/recordingVote',
        RecordingVoteSearchParams
    >();
    const { DialogueRecordingVoteScreen, RecordingVoteScreen } = useModule(questionModuleQuery);
    const { Dialogue, commentslider } = useEnabledFeatures();
    const screenParams = { csrfToken: csrfToken1, sliderValue: sliderValue1, voteKey: voteKey1, voteLabel: voteLabel1 };

    if (Dialogue) {
        return (
            <ParamProvider screenParams={screenParams}>
                <DialogueRecordingVoteScreen />
            </ParamProvider>
        );
    }
    if (commentslider) {
        return (
            <ParamProvider screenParams={screenParams}>
                <RecordingVoteScreen />
            </ParamProvider>
        );
    }

    return <NotFound />;
}
